<script lang="ts" setup>
import type { Person } from "~~/sanity.types";

const props = defineProps<{
  person: Person;
}>();

const initials = computed(() =>
  props.person.name
    ?.split(" ")
    .map((namePart) => namePart[0])
    .join("")
);
</script>

<template>
  <NuxtLink :to="`/people/${person.slug?.current}`">
    <UCard>
      <div class="flex gap-4 justify-start items-center">
        <div
          v-if="person.name"
          class="size-12 rounded-full flex items-center justify-center bg-gray-500 text-gray-100 dark:text-gray-900 text-xl font-semibold tracking-tighter"
        >
          {{ initials }}
        </div>

        <div>
          <h2 class="text-xl font-semibold tracking-tight">
            {{ person.name }}
          </h2>

          <PersonStats :person="person" />
        </div>
      </div>
    </UCard>
  </NuxtLink>
</template>
